<template>
    <div
        class="multiselectWithPills"
    >
        <label
            :class="{ 'kgr-inputGroup': label !== null, 'kgr-inputGroup--inline': label !== null && inline }"
        >
            <div
                v-if="label !== null"
                class="kgr-inputGroup__label"
            >
                {{ label }}
            </div>
            <kgr-searchable-dropdown
                v-if="searchable"
                :display="display"
                :inline="inline"
                :options="removeSelected ? availableOptions: options"
                :loading="loading"
                :disabled="disabled || isMaxSelectsReached"
                :style="[selectControlWidth ? { width: selectControlWidth } : {} ]"
                clear-after-select
                @post-input="add($event)"
                @inputChanged="$emit('inputChanged', $event)"
            />
            <kgr-generic-select
                v-else
                :options="removeSelected ? availableOptions: options"
                :display="display"
                :inline="inline"
                :style="[selectControlWidth ? { width: selectControlWidth } : {} ]"
                :disabled="disabled || isMaxSelectsReached"
                @post-input="add($event)"
            />
            <div
                class="multiselectWithPills__selectedValuesWrapper"
            >
                <span
                    v-for="(element, index) in value"
                    :key="index"
                    class="kgr-appliedFilter"
                    :class="{'disabledPill' : disabled}"
                    @click.prevent="remove(element)"
                >
                    <span class="kgr-appliedFilter__label">
                        {{ displayOption(element) }}
                    </span>
                    <kgr-icon
                        v-if="!disabled"
                        icon-class="clear"
                        class="kgr-appliedFilter__close"
                    />
                </span>
            </div>
        </label>
    </div>
</template>

<script>
import GenericSelect from './GenericSelect';
import Icon from '../../icon/Icon';
import SearchableDropdown from './SearchableDropdown.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
        'kgr-searchable-dropdown': SearchableDropdown,
        'kgr-icon': Icon,
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: true,
        },
        selectControlWidth: {
            type: String,
            required: false,
            default: null,
        },
        searchable: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        display: {
            type: String,
            required: false,
            default: 'label',
        },
        maxSelects: {
            type: Number,
            required: false,
            default: -1
        },
        removeSelected: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        isMaxSelectsReached() {
            if(this.maxSelects > 0 && this.value && this.value.length >= this.maxSelects) {
                return true;
            }
            return false;
        },
        availableOptions() {
            return this.options.filter(option => !this.value.includes(option));
        }
    },
    methods: {
        add(element) {
            if (element === null) {
                return;
            }

            let value = this.value.slice();
            value.push(element);
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
        remove(element) {
            if (this.disabled) {
                return;
            }
            let value = this.value.slice();
            let index = value.indexOf(element);
            value.splice(index, 1);
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
        displayOption(element) {
            if(!element) {
                return '';
            }
            if (this.display) {
                return typeof element[this.display] === 'function' ? element[this.display]() : element[this.display];
            }

            return this.$t(element);
        },

    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.multiselectWithPills__selectedValuesWrapper {
    margin-top: var(--kgr-default-margin-tiny);
    text-align: left;
}
.kgr-appliedFilter.disabledPill {
    cursor: not-allowed;
}
</style>
